import AsyncStorage from '@react-native-async-storage/async-storage';
import { AesUtil } from './AesUtil';
import { GLOBAL_IV, GLOBAL_SALT } from '../config/Constant';
import { setGoHome, setIsShownWelcomeScreen, setOpenChat, setProceedHotelSelection, setRedirectToTabId, setShowLoginModal, setTempSelectedHotel } from '../Redux/Reducers/appConfigReducer';
import { setProceedLoginToTheApp, setRenderFlashMessage, setRenderLoader } from '../Redux/Actions/appConfigAction';
import { setCurrentWidget } from '../Redux/Reducers/deviceConfigReducer';
import { setRedirectInfo } from '../Redux/Reducers/deeplinkReducer';
import { Linking, Platform } from 'react-native';
import { CHECK_IN } from '../navigation/StackNavigator/routes';
import { setGuestRoomData } from '../Redux/Reducers/guestRoomReducer';
import { checkBookingStatus } from '../Redux/Actions/checkInAction';


export const redirectToDeepLink = () => {
    const deepLinkVar = process.env.REACT_APP_DEEPLINK_CONFIG
      ? process.env.REACT_APP_DEEPLINK_CONFIG.toLowerCase()
      : process.env.REACT_APP_CLIENT_CONFIG.split("_")[1].toLowerCase();
  
    let deeplinkConstant = `https://${deepLinkVar}.s3.amazonaws.com/static/redirect.html?downloadApp=True&eventName=${Platform.OS == "web" ? 'WEB_APP_CLICK' : 'NATIVE_APP_CLICK'}`;
  
    Linking.openURL(deeplinkConstant).catch(err => console.log("Failed to open URL:", err));
};


let isGuestDetailstokenVerified = false;
export const handleDeepLinkAction = (eventData, navigation) => {

    console.log("in handleDeepLinkAction:", eventData);
    return async (dispatch, getState) => {

        const {  shownWelcomeScreen, allowUserSelectLocation } = getState().appConfigSlice

        const { webAppWidgetsInfo } = getState().deviceConfigSlice;
        const { allowUserLoginViaFindingReservation } = webAppWidgetsInfo?.appConfigs || {};

        const { hotelListData } = getState().hotelSelectorSlice;

        if(!eventData?.params || Object.keys(eventData?.params).length == 0){
            return;
        }

        let aesUtil = new AesUtil(128, 1000);
        const { isLoggedIn } = getState().appConfigSlice;
        const { isBookingFound } = getState().checkInSlice.bookingStatus
        
        const hotel_code = eventData.params.hotel ? eventData.params.hotel : null
        const current_hotel_code =  getState().appConfigSlice.clientId?.replace("GJ_", "").toUpperCase();
        

        if(hotel_code && hotel_code != current_hotel_code){
            dispatch(setProceedHotelSelection({init: true, hotel_Code: hotel_code}))
            return;
        }

        const loginAuthToken = eventData.params.loginAuthToken;
        if(loginAuthToken && !isLoggedIn){
            let loginGuestInfo = JSON.parse(aesUtil.decrypt(GLOBAL_SALT, GLOBAL_IV, "1234567891234567", loginAuthToken ));
            dispatch(setProceedLoginToTheApp(true, { lastName: loginGuestInfo?.lastName, roomNumber: loginGuestInfo?.roomNumber, checkinDate: loginGuestInfo?.checkinDate, confirmationNumber: loginGuestInfo?.confirmationNumber  }));
            return;
        }


        const guestDetailsToken = eventData.params.guestDetailsToken;
        if(guestDetailsToken && !isLoggedIn && !isGuestDetailstokenVerified){
            let checkInGuestPreInfo = atob(guestDetailsToken);

            if(checkInGuestPreInfo) {
                checkInGuestPreInfo = JSON.parse(checkInGuestPreInfo);
                let guestDetails = {
                    lastName: checkInGuestPreInfo?.lastName || '',
                    roomNumber: checkInGuestPreInfo?.roomNumber || '',
                    confirmationNumber: checkInGuestPreInfo?.confirmationNumber || checkInGuestPreInfo?.bookingNumber || '',
                    checkinDate: checkInGuestPreInfo?.checkinDate || '',
                }
                dispatch(setGuestRoomData({guestDetails: guestDetails}));

                let bookingStatus;
                if(allowUserLoginViaFindingReservation){
                    if(allowUserSelectLocation){
                        if(hotel_code && hotelListData){
                            const hotelListsInfo = hotelListData?.payload?.data;
                            for (const hotelDataWithRegion of hotelListsInfo) {
                                if (hotelDataWithRegion.hotelList && hotelDataWithRegion.hotelList?.length > 0) {
                                    for (const hotelData of hotelDataWithRegion.hotelList) {
                                        if (hotelData.hotelPropertyKey === hotel_code) {
                                            dispatch(setTempSelectedHotel(hotelData));
                                            dispatch(setRenderLoader(true, "Verifying booking details..."))
                                            bookingStatus = await dispatch(checkBookingStatus(guestDetails, "", "DEEP_LINK", hotelData));
                                        }
                                    }
                                }
                            }
                        }
                    } else {
                        dispatch(setRenderLoader(true, "Verifying booking details..."))
                        bookingStatus = await dispatch(checkBookingStatus(guestDetails, "", "DEEP_LINK"));
                    }

                    dispatch(setRenderLoader(false))
                    isGuestDetailstokenVerified = true;

                    console.log("deeplink: guestDetailsToken bookingstatus: ", bookingStatus)
                    if(bookingStatus.status == "LINKTOROOM" || bookingStatus.status == "BOOKING_SUCCESS_ANOTHER_CONNECTOR"){

                    } else if(bookingStatus.status == "FAILURE"){
                        dispatch(setRenderFlashMessage(true, { type: "danger", message: bookingStatus.message }));
                        dispatch(handleDeepLinkAction(eventData, navigation));
                    } else {
                        dispatch(handleDeepLinkAction(eventData, navigation));
                    }
                    return;
                }
            }
        }

        dispatch(setRedirectInfo({}));

        if(!shownWelcomeScreen){
            setTimeout(() => {
                dispatch(setIsShownWelcomeScreen(true));
            }, 0);
        }

        setTimeout(() => {
        // navigate to required bottom tab
        const bottomTabId = eventData?.params?.bottomTabId;
        if(bottomTabId) dispatch(setRedirectToTabId(bottomTabId));
        
        // navigate to required screen
        const appPath = eventData?.params?.appPath;
        const storeSku = eventData?.params?.storeSku;
        const { currentLayout } = getState().deviceConfigSlice;
        const widgetList = currentLayout?.scrollableWidgets || [];

        if (appPath && widgetList.length > 0) {
            if(appPath == "chat"){
                dispatch(setOpenChat(true));
                return;
            }

            if(appPath.toLowerCase() == "findres"){
                dispatch(setShowLoginModal(true));
                return;
            }

            if(appPath.toLowerCase() == CHECK_IN && isLoggedIn){
                return;
            }
            
            dispatch(setCurrentWidget({
                widgetType: "deeplink",
                storeSku: storeSku
            }));
            navigation.navigate(appPath)
        }
    }, 500);
    }
}